import IcoIconContainer from "../../components/icon/icoIcon";

const IcoIcon = () => {
  return <IcoIconContainer />;
};

export default IcoIcon;
